export const PATH = {
  PAGE_NOT_FOUND: '/404'
}

export const KEY_STORE = {
  LOCALE: 'LOCALE',
  METAMASK: 'METAMASK',
  USER_AUTHENTICATION: 'USER_AUTHENTICATION'
}

export const METAMASK_STATUS = {
  LOADING: 'loading',
  NOWEB3: 'noweb3',
  ERROR: 'error',
  LOCKED: 'locked',
  CHANGEACCOUNT: 'changeaccount',
  READY: 'ready'
}

export const TOMO_NETWORK = [
  { key: 88, type: 'Mainnet' },
  { key: 89, type: 'Testnet' }
]